/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type GetOrgQuotaAuthOrgsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class GetOrgQuotaAuthOrgsResponse429ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetOrgQuotaAuthOrgsResponse429ResponseBodyData;

  constructor(
    err: GetOrgQuotaAuthOrgsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetOrgQuotaAuthOrgsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type GetOrgQuotaAuthOrgsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class GetOrgQuotaAuthOrgsResponse409ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetOrgQuotaAuthOrgsResponse409ResponseBodyData;

  constructor(
    err: GetOrgQuotaAuthOrgsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetOrgQuotaAuthOrgsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type GetOrgQuotaAuthOrgsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class GetOrgQuotaAuthOrgsResponse404ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetOrgQuotaAuthOrgsResponse404ResponseBodyData;

  constructor(
    err: GetOrgQuotaAuthOrgsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetOrgQuotaAuthOrgsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type GetOrgQuotaAuthOrgsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class GetOrgQuotaAuthOrgsResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetOrgQuotaAuthOrgsResponseResponseBodyData;

  constructor(
    err: GetOrgQuotaAuthOrgsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetOrgQuotaAuthOrgsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type GetOrgQuotaAuthOrgsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class GetOrgQuotaAuthOrgsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetOrgQuotaAuthOrgsResponseBodyData;

  constructor(
    err: GetOrgQuotaAuthOrgsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetOrgQuotaAuthOrgsResponseBody";
  }
}

/**
 * Bad request
 */
export type GetOrgQuotaResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class GetOrgQuotaResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetOrgQuotaResponseBodyData;

  constructor(
    err: GetOrgQuotaResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetOrgQuotaResponseBody";
  }
}

/** @internal */
export const GetOrgQuotaAuthOrgsResponse429ResponseBody$inboundSchema:
  z.ZodType<GetOrgQuotaAuthOrgsResponse429ResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new GetOrgQuotaAuthOrgsResponse429ResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type GetOrgQuotaAuthOrgsResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetOrgQuotaAuthOrgsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    GetOrgQuotaAuthOrgsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    GetOrgQuotaAuthOrgsResponse429ResponseBody
  > = z.instanceof(GetOrgQuotaAuthOrgsResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetOrgQuotaAuthOrgsResponse409ResponseBody$inboundSchema:
  z.ZodType<GetOrgQuotaAuthOrgsResponse409ResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new GetOrgQuotaAuthOrgsResponse409ResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type GetOrgQuotaAuthOrgsResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetOrgQuotaAuthOrgsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    GetOrgQuotaAuthOrgsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    GetOrgQuotaAuthOrgsResponse409ResponseBody
  > = z.instanceof(GetOrgQuotaAuthOrgsResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetOrgQuotaAuthOrgsResponse404ResponseBody$inboundSchema:
  z.ZodType<GetOrgQuotaAuthOrgsResponse404ResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new GetOrgQuotaAuthOrgsResponse404ResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type GetOrgQuotaAuthOrgsResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetOrgQuotaAuthOrgsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    GetOrgQuotaAuthOrgsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    GetOrgQuotaAuthOrgsResponse404ResponseBody
  > = z.instanceof(GetOrgQuotaAuthOrgsResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetOrgQuotaAuthOrgsResponseResponseBody$inboundSchema: z.ZodType<
  GetOrgQuotaAuthOrgsResponseResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetOrgQuotaAuthOrgsResponseResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetOrgQuotaAuthOrgsResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetOrgQuotaAuthOrgsResponseResponseBody$outboundSchema: z.ZodType<
  GetOrgQuotaAuthOrgsResponseResponseBody$Outbound,
  z.ZodTypeDef,
  GetOrgQuotaAuthOrgsResponseResponseBody
> = z.instanceof(GetOrgQuotaAuthOrgsResponseResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const GetOrgQuotaAuthOrgsResponseBody$inboundSchema: z.ZodType<
  GetOrgQuotaAuthOrgsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetOrgQuotaAuthOrgsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetOrgQuotaAuthOrgsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetOrgQuotaAuthOrgsResponseBody$outboundSchema: z.ZodType<
  GetOrgQuotaAuthOrgsResponseBody$Outbound,
  z.ZodTypeDef,
  GetOrgQuotaAuthOrgsResponseBody
> = z.instanceof(GetOrgQuotaAuthOrgsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const GetOrgQuotaResponseBody$inboundSchema: z.ZodType<
  GetOrgQuotaResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetOrgQuotaResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetOrgQuotaResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetOrgQuotaResponseBody$outboundSchema: z.ZodType<
  GetOrgQuotaResponseBody$Outbound,
  z.ZodTypeDef,
  GetOrgQuotaResponseBody
> = z.instanceof(GetOrgQuotaResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
